import React, {Dispatch, SetStateAction, useRef, useState} from 'react';
import s from './KycPersonalStepTwo.module.css'
import { Formik, Form} from "formik";
import MyInput from "../../../../../../components/ui/MyInput/MyInput";
import info from '../../../../../../assets/newImg/personalAccount/information.svg'
import {Popover} from "antd";
import MyBtn from "../../../../../../components/ui/MyBtn/MyBtn";
import * as yup from "yup";
import CustomCheckbox from "../../../../../../components/ui/customCheckbox/CustomCheckbox";
import classnames from "classnames";
import passportSpread from "../../../../../../assets/newImg/personalAccount/passport_spread.png"
import {ReactComponent as Back} from "../../../../../../assets/newImg/personalAccount/back.svg"
import selfi from "../../../../../../assets/newImg/personalAccount/selfi.png"
import proof from "../../../../../../assets/newImg/personalAccount/proof.png"
import {useAppDispatch, useAppSelector} from "../../../../../../hooks/redux";
import {sendPersonalKycThunk, setTokenState} from "../../../../../../store/reducers/ActionCreators";
import CustomModal from "../../../../../../components/ui/CustomModal/CustomModal";
import {motion} from 'framer-motion';
import {setDisabled} from "../../../../../../store/reducers/UserSlice";
import CustomDropdown from '../../../../../../components/ui/CustomDropdown/CustomDropdown';
import Icon from "@ant-design/icons";
import TransparentButton from "../../../../../../components/ui/TransparentButton/TransparentButton";
import {countries} from "../../../../../../Constants/StaticData";
import SelectWithSearch from "../../../../../../components/ui/SelectWithSearch/SelectWithSearch";
import FileInput from '../../../../../../components/FileInput/FileInput';
import { getPhoneNumberList } from '../../../../../../Constants/KycConstants';

type PropsType = {
    current: number
    setCurrent: Dispatch<SetStateAction<number>>
}

const validationSchema = yup.object({
    phoneNumber: yup.string()
        .required('Required field'),
    firstName: yup.string()
        .max(60, 'max 60')
        .required('Required field'),
    lastName: yup.string()
        .required('Required field')
        .max(60, 'max 60'),
    country: yup.string().required('Required field'),
    otherSourcesOfWealth: yup.string().test({
        message: 'Required field',
        test: function (value) {
            const {otherSourcesOfWealth} = this.parent;
            if (otherSourcesOfWealth) return value !== undefined && value !== null && value !== '';
            return true
        },
    }),
    sourcesOfWealth: yup.string().test({
        message: 'At least one source is required',
        test: function (value) {
            const {otherSourcesOfWealth} = this.parent;
            if (!otherSourcesOfWealth) return value !== undefined && value !== null && value.length > 0;
            return true
        },
    }),
})

const KycPersonalStepTwo = (props: PropsType) => {

    const token: string = useAppSelector(state => state.userReducer.user.userToken)
    const dispatch = useAppDispatch()
    const firstNameRef = useRef<any>(null!)

    const [documents, setDocuments] = useState<any>(
        {
            passportSpread: '',
            selfie: '',
            proofOfAddress: '',
        }
    )

    const [docsError, setDocsError] = useState(false)
    const [isPep, setIsPep] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("Something went wrong. Please try again later.");
    
    const phoneList = useAppSelector(
        (state) => state.userReducer.user.phoneList
    );

    const sourcesOfWealthList = [
        'Inheritances',
        'Investments',
        'Business ownership interests',
        'Employment income',
        'Personal savings',
        'Pension releases',
        'Share sales and dividends',
        'Property sales',
        'Gambling winnings',
        'Inheritances and gifts',
        'Compensation from legal rulings',
        'Other'
    ];

    const closeAndRedirect = () => {
        setIsModalOpen(false)
        props.setCurrent(0)
    }

    function toBase64(file: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    return (
        <motion.div
            initial={{opacity: 0, scale: 1}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
        >
            <div className={s.wrapper}>

                <CustomModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen}>
                    <div className={s.flex}>
                        <div className={s.modal_title}>
                            Success!
                        </div>
                        <div className={s.modal_subtitle}>
                            Your details have been sent for review.
                        </div>
                        <div className={s.button_block}>
                            <MyBtn title={"Ok"} onClick={() => closeAndRedirect()}/>
                        </div>
                    </div>
                </CustomModal>
                <CustomModal type="error" isModalOpen={isErrorModalOpen} setIsModalOpen={setIsErrorModalOpen}>
                    <div className={s.flex}>
                        <div className={s.modal_title}>
                            Oops!
                        </div>
                        <div className={s.modal_subtitle}>
                            {errorMessage}
                        </div>
                        <div className={s.button_block}>
                            <MyBtn buttonType="error" title={"Ok"} onClick={() => setIsErrorModalOpen(false)}/>
                        </div>
                    </div>
                </CustomModal>

                <div className={s.page_title}>
                    KYC for Personal Accounts
                </div>

                <Formik
                    initialValues={{
                        firstName: '',
                        lastName: '',
                        country: '',
                        phoneNumber: '',
                        sourcesOfWealth: '',
                        // isOtherSourcesOfWealth: false,
                        otherSourcesOfWealth: '',
                        pep: false,
                        files: {
                            passportSpread: '',
                            selfie: '',
                            proofOfAddress: '',
                        }
                    }}
                    validationSchema={validationSchema}
                    onSubmit={async (values, formikHelpers) => {

                        const tempData = {
                            ...values,
                            sourcesOfWealth: [values.sourcesOfWealth],
                            phoneNumber: values.phoneNumber,
                            pep: isPep,
                            files: {
                                passportSpread: '',
                                selfie: '',
                                proofOfAddress: '',
                            }
                        }

                        if (tempData.otherSourcesOfWealth) {
                            tempData.sourcesOfWealth = []
                            // @ts-ignore
                            tempData.sourcesOfWealth.push(tempData.otherSourcesOfWealth)
                        }

                        // @ts-ignore
                        delete tempData.otherSourcesOfWealth

                        if (documents.passportSpread === '' ||
                            documents.selfie === '' ||
                            documents.proofOfAddress === ''
                        ) {
                            setDocsError(true)
                            return
                        }

                        tempData.files.passportSpread = await toBase64(documents.passportSpread) as string
                        tempData.files.proofOfAddress = await toBase64(documents.proofOfAddress) as string
                        tempData.files.selfie = await toBase64(documents.selfie) as string

                        console.log(tempData)

                        dispatch(sendPersonalKycThunk(token, tempData))
                            .then((res) => {
                                if (res.data === "Created") {
                                    setIsModalOpen(true)
                                } else {
                                    setIsErrorModalOpen(true)
                                }
                            })
                            .catch((error) => {

                                console.log(error.response.data);

                                if (error.response.data === "Invalid authorization data") {
                                    dispatch(setTokenState(false))
                                    return
                                }

                                if (error.response.data === "Too many phones. Max count is 5") {
                                    setErrorMessage(error.response.data)
                                    setIsErrorModalOpen(true)
                                    return
                                }

                                if (error.response.data === "Phone already exist") {
                                    setErrorMessage("This phone number already exists. Please try another phone number.")
                                    setIsErrorModalOpen(true)
                                    return
                                }

                                if (error.code === "ERR_NETWORK" && !error.response) {
                                    setErrorMessage("Maximum files size is 17 MB")
                                    setIsErrorModalOpen(true)
                                } else {
                                    setErrorMessage("Something went wrong. Please try again later.")
                                    setIsErrorModalOpen(true)
                                }
                            })
                            .finally(() => {
                                dispatch(setDisabled(false))
                            })
                    }}
                >
                    {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit
                      }) => (
                        <Form onSubmit={handleSubmit}>
                            <div className={s.row}>
                                <div className={s.input_block} ref={firstNameRef}>
                                    <div className={s.input_label}>
                                        * First name
                                        <Popover content={"Enter your First Name as in the ID document."}
                                                 color={'#EEEFEF'}
                                                 overlayInnerStyle={{
                                                     fontFamily: 'Inter',
                                                     width: '280px',
                                                     padding: '13px 16px'
                                                 }}
                                        >
                                            <img src={info} alt=""/>
                                        </Popover>
                                    </div>
                                    <MyInput id='firstName'
                                             name='firstName'
                                             onChange={handleChange}
                                             value={values.firstName}
                                             isError={errors.firstName}
                                             touched={touched.firstName}
                                    />
                                    {errors.firstName &&
                                        <div className={s.error_message}>{errors.firstName}</div>}
                                </div>

                                <div className={s.input_block}>
                                    <div className={s.input_label}>
                                        * Last name
                                        <Popover content={"Enter your Last Name as in the ID document."}
                                                 color={'#EEEFEF'}
                                                 overlayInnerStyle={{
                                                     fontFamily: 'Inter',
                                                     width: '280px',
                                                     padding: '13px 16px'
                                                 }}
                                        >
                                            <img src={info} alt=""/>
                                        </Popover>
                                    </div>
                                    <MyInput id='lastName'
                                             name='lastName'
                                             onChange={handleChange}
                                             value={values.lastName}
                                             isError={errors.lastName}
                                             touched={touched.lastName}
                                    />
                                    {errors.lastName &&
                                        <div className={s.error_message}>{errors.lastName}</div>}
                                </div>
                            </div>

                            <div className={s.row}>
                                <div className={s.input_block}>
                                    <div className={s.input_label}>
                                        * Country
                                    </div>
                                    <SelectWithSearch
                                        id="country"
                                        name="country"
                                        isError={errors.country}
                                        touched={touched.country}
                                        items={countries}
                                    />
                                    {errors.country &&
                                        <div className={s.error_message}>{errors.country}</div>}
                                </div>

                                <div className={s.input_block}>
                                    <div className={s.input_label}>
                                        * Phone number
                                    </div>
                                    <CustomDropdown
                                        items={getPhoneNumberList(phoneList)}
                                        placeholder={"Choose your phone number"}
                                        id="phoneNumber"
                                        name="phoneNumber"
                                        isError={errors.phoneNumber}
                                        touched={touched.phoneNumber}
                                    />
                                    {errors.phoneNumber &&
                                        <div className={s.error_message}>{errors.phoneNumber}</div>}
                                </div>
                            </div>

                            <div className={s.row}>
                                <div className={classnames(s.input_block)}>
                                    <div className={s.input_label}>
                                        * Sources of wealth or income
                                    </div>
                                        <CustomDropdown
                                            items={sourcesOfWealthList}
                                            placeholder={"Choose your source"}
                                            id="sourcesOfWealth"
                                            name="sourcesOfWealth"
                                            touched={touched.sourcesOfWealth}
                                            isError={errors.sourcesOfWealth}
                                        />
                                        {errors.sourcesOfWealth && values.sourcesOfWealth.length === 0 &&
                                            <div className={s.error_message}>{errors.sourcesOfWealth}</div>}
                                </div>
                                <div className={s.input_block}>
                                {
                                    // @ts-ignore
                                    values.sourcesOfWealth === 'Other' &&
                                    <div className={s.input_block}>
                                        <div className={s.input_label}>
                                            * Other
                                        </div>
                                        <MyInput id='otherSourcesOfWealth'
                                                 name='otherSourcesOfWealth'
                                                 onChange={handleChange}
                                                 value={values.otherSourcesOfWealth}
                                                 isError={errors.otherSourcesOfWealth}
                                                 touched={touched.otherSourcesOfWealth}
                                        />
                                        { errors.otherSourcesOfWealth &&
                                            <div className={s.error_message}>{errors.otherSourcesOfWealth}</div> }
                                    </div>
                                }
                                </div>
                            </div>

                            <div className={s.row}>
                                <div className={s.input_block}>
                                    <div className={s.input_label}>
                                        * Politically Exposed Person (PEP)
                                    </div>
                                    <div className={classnames(s.flex_label, s.radio_block)}>
                                        <label className={s.flex_label}>
                                            <CustomCheckbox
                                                handleChange={() => setIsPep(false)}
                                                id="No"
                                                name="No"
                                                isChecked={!isPep}
                                            />
                                            <span className={s.type_of_account}>No</span>
                                        </label>
                                        <label className={s.flex_label}>
                                            <CustomCheckbox
                                                handleChange={() => setIsPep(true)}
                                                id="Yes"
                                                name="Yes"
                                                isChecked={isPep}
                                            />
                                            <span className={s.type_of_account}>Yes</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className={s.line}></div>

                            <div className={s.add_doc_block}>
                                <div className={s.content_block}>
                                    <div>
                                        <img src={passportSpread} alt=""/>
                                    </div>
                                    <div>
                                        <div
                                            className={classnames(s.title, docsError && documents.passportSpread === '' && s.doc_error)}>
                                            <span className={s.required}>* </span>
                                            Passport spread with your photo
                                        </div>
                                        <div>
                                            <ul className={s.passport_spread_list}>
                                                <li>
                                        <span className={s.text_color}>
                                            A color photo contains full document in clear focus and the data can be read
                                            easily.
                                        </span>
                                                </li>
                                                <li>
                                        <span className={s.text_color}>
                                             There're no light glares impeding document readability.
                                        </span>
                                                </li>
                                                <li>
                                        <span className={s.text_color}>
                                            A photo was not edited in graphic applications (we will definitely check).
                                        </span>
                                                </li>
                                                <li>
                                        <span className={s.text_color}>
                                           Picture format: JPEG, JPG, PNG, HEIC, PDF.
                                        </span>
                                                </li>
                                                <li>
                                        <span className={s.text_color}>
                                            Maximum file size: 8Mb.
                                        </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <FileInput
                                    s={s}
                                    documents={documents}
                                    key={"passportSpread"}
                                    inputId={"passportSpread"}
                                    allowedTypes={[".png", ".jpg", ".jpeg", ".pdf", ".heic"]}
                                    identifier={"passportSpread"}
                                    maxFileSize={8}
                                    onChange={(event) => {
                                        setDocuments({
                                            ...documents,
                                                // @ts-ignore
                                                passportSpread: event.currentTarget.files[0]
                                        });
                                    }}
                                    onImageClick={() => {
                                        // @ts-ignore
                                        document.getElementById("passportSpread").value = ""
                                        setDocuments({...documents, passportSpread: ""})
                                    }}
                                />

                            </div>

                            <div className={s.line}></div>

                            <div className={s.add_doc_block}>
                                <div className={s.content_block}>
                                    <div>
                                        <img src={selfi} alt=""/>
                                    </div>
                                    <div>
                                        <div
                                            className={classnames(s.title, docsError && documents.selfie === '' && s.doc_error)}>
                                            <span className={s.required}>* </span>
                                            Selfie with your Passport
                                        </div>
                                        <div className={s.add_block_text}>
                                            Upload a selfie of the Account Holder holding his Passport (at the page with a photo) in one hand and 
                                            a paper with written name of platform "Mondial", date (dd/mm/yyyy/) and Account Holder's signature 
                                            in the other hand. Photo should be good enough so it is possible to read ID data and see written on 
                                            the paper text. You can use help of another person to make this photo or use a delayed photo function 
                                            on your phone.
                                        </div>
                                    </div>
                                </div>
                                <FileInput
                                    s={s}
                                    documents={documents}
                                    key={"selfie"}
                                    inputId={"selfie"}
                                    allowedTypes={["image/png", "image/jpeg", ".pdf"]}
                                    identifier={"selfie"}
                                    maxFileSize={8}
                                    onChange={(event) => {
                                        setDocuments({
                                            ...documents,
                                                // @ts-ignore
                                                selfie: event.currentTarget.files[0]
                                        });
                                    }}
                                    onImageClick={() => {
                                        // @ts-ignore
                                        document.getElementById("selfie").value = ""
                                        setDocuments({...documents, selfie: ""})
                                    }}
                                />

                            </div>

                            <div className={s.line}></div>

                            <div className={s.add_doc_block}>
                                <div className={s.content_block}>
                                    <div>
                                        <img src={proof} alt=""/>
                                    </div>
                                    <div>
                                        <div
                                            className={classnames(s.title, docsError && documents.proofOfAddress === '' && s.doc_error)}>
                                            <span className={s.required}>* </span>
                                            Personal Proof of Address
                                        </div>
                                        <div>
                                            <ul className={s.passport_spread_list}>
                                                <li>
                                                    <span className={s.text_color}>
                                                        Bank statement with the date of issue and the name of the person (the document
                                                        must be not older than 3 months);
                                                    </span>
                                                </li>
                                                <li>
                                                    <span className={s.text_color}>
                                                         Utility bill for gas, electricity, water, internet, etc. linked to the property
                                                        (the document must not be older than 3 months).
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <FileInput
                                    s={s}
                                    documents={documents}
                                    key={"proofOfAddress"}
                                    inputId={"proofOfAddress"}
                                    allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
                                    identifier={"proofOfAddress"}
                                    maxFileSize={8}
                                    onChange={(event) => {
                                        setDocuments({
                                            ...documents,
                                                // @ts-ignore
                                                proofOfAddress: event.currentTarget.files[0]
                                        });
                                    }}
                                    onImageClick={() => {
                                        // @ts-ignore
                                        document.getElementById("proofOfAddress").value = ""
                                        setDocuments({...documents, proofOfAddress: ""})
                                    }}
                                />

                            </div>

                            <div className={s.line}></div>

                            <div className={s.btn_block}>
                                <div className={s.button_back_wrapper}>
                                    <TransparentButton title={"Back"}
                                                       personalAccount={true}
                                                       large
                                                       style={{width: '100%'}}
                                                       onClick={() => props.setCurrent(0)}
                                                       icon={<Icon component={() => <Back/>} rev={undefined}/>}
                                    />
                                </div>
                                <div className={s.button_apply_wrapper}>
                                    <MyBtn title={'Apply'} type={"submit"} personalAccount={true} onClick={() => console.log(errors)}/>
                                </div>
                            </div>

                        </Form>
                    )}
                </Formik>


            </div>
        </motion.div>
    )


};

export default KycPersonalStepTwo;
